/**
 * 照らす「週報」パターン ギャラリー（DEV/デモ専用・週報のみ）。
 * ?w=CODE で1パターン単票（PDF生成用）。既定は代表サブセット表示。?all=1 で全256。
 */
import React from 'react';
import { Box, Paper, Typography, Divider } from '@mui/material';
import { TerasuReport } from './TerasuReport';
import { generateDummyTerasuReport } from '../utils/generateDummyTerasuReport';
import { weeklyAllPatterns, weeklyRepresentative } from '../utils/demoTerasuPatterns';

export const TerasuWeeklyPatternsDemoPage: React.FC = () => {
  const params =
    typeof window !== 'undefined' ? new URLSearchParams(window.location.search) : new URLSearchParams();
  const w = params.get('w');
  const showAll = params.get('all') === '1';

  const all = weeklyAllPatterns();
  if (w) {
    const p = all.find((x) => x.code === w);
    if (!p) return <Box sx={{ p: 3 }}>該当パターンなし</Box>;
    const data = generateDummyTerasuReport({ weekWeather: p.weekWeather });
    return (
      <Box sx={{ maxWidth: 720, mx: 'auto', px: 2, py: 3 }}>
        <Paper variant="outlined" sx={{ p: 1, mb: 1, bgcolor: '#FFF8E1' }}>
          <Typography variant="subtitle1" fontWeight={700}>
            週報｜{p.label}（{p.code}）
          </Typography>
        </Paper>
        <TerasuReport data={data} mode="weekly" />
      </Box>
    );
  }

  const list = showAll ? all : weeklyRepresentative();
  return (
    <Box sx={{ maxWidth: 760, mx: 'auto', px: 2, py: 3 }}>
      <Paper variant="outlined" sx={{ p: 2, mb: 2 }}>
        <Typography variant="h6">GBなび 週報パターン{showAll ? '（全256）' : '（代表12）'}</Typography>
        <Typography variant="body2" color="text.secondary">
          週報のみ。4指標×4天気の組み合わせ。?all=1 で全256、?w=CODE で単票。
        </Typography>
      </Paper>
      {list.map((p) => {
        const data = generateDummyTerasuReport({ weekWeather: p.weekWeather });
        return (
          <Box key={p.code} sx={{ mb: 4 }}>
            <Paper variant="outlined" sx={{ p: 1, mb: 1, bgcolor: '#FFF8E1' }}>
              <Typography variant="subtitle1" fontWeight={700}>
                {p.label}（{p.code}）
              </Typography>
            </Paper>
            <TerasuReport data={data} mode="weekly" />
            <Divider sx={{ mt: 3 }} />
          </Box>
        );
      })}
    </Box>
  );
};

export default TerasuWeeklyPatternsDemoPage;
